import ReleasePage from '@/components/ReleasePage';
import useGetVariantById from '@/hooks/queries/public_user/useGetVariantById';
import { User, Variant, WaitList } from '@/lib/interfaces';
import { releasePageProps } from '@/utils/sspFunctions';
import { genQs } from '@/utils/v2HelperMethods';
import { GetServerSideProps } from 'next';
import { NextSeo } from 'next-seo';
import seo from 'next-seo.config';

export const getServerSideProps: GetServerSideProps = async (ctx) =>
  releasePageProps(ctx, 'Mending Love');

export default function KaiMendingLoveReleasePage({
  variants,
  user,
  waitlist,
}: {
  variants: Variant[];
  user: User | null;
  waitlist: WaitList | null;
}) {
  const variantsQuery = useGetVariantById(
    variants[0].id,
    genQs({ populate: { image: true, artist: true } })
  );
  const variantsQueryOne = useGetVariantById(
    variants[1].id,
    genQs({ populate: { image: true, artist: true } })
  );

  return (
    <>
      <NextSeo
        {...seo}
        openGraph={{
          type: 'website',
          locale: 'en_IE',
          url: 'https://olea.art/',
          title: 'OLEA',
          description: 'OLEA',
          images: [
            {
              url: 'https://res.cloudinary.com/hmkqf8kua/image/upload/v1668716207/ArtMiami2022/events/Together_FINAL_with_Background_Neon-01_w4w95p.jpg',
              width: 32,
              height: 32,
              alt: 'OLEA',
              type: 'image/png',
            },
          ],
          site_name: 'OLEA',
        }}
      />
      {variantsQuery.isSuccess && variantsQueryOne.isSuccess ? (
        <ReleasePage
          variants={[variantsQuery.data, variantsQueryOne.data]}
          user={user}
          waitlist={waitlist}
          redirect={'/releases/mending-love'}
          loginRequired={false}
          buyNow={false}
          releaseDateCopy={'DEC 15 @ 10AM PST'}
          showInventoryLeft={false}
          description={
            <p>
              SOLD OUT. For early access to upcoming releases, please register
              for Kai&rsquo;s exclusive waitlist below.
            </p>
          }
        />
      ) : (
        <></>
      )}
    </>
  );
}
